import { IWebsiteBuilderRoot } from "pages/secure/facility/websiteBuilder/editor/nodes/root/websiteBuilderRoot";
import { IWebsiteBuilderHistorySnapshot } from "../websiteBuilderEditorAction";
import { IWebsiteBuilderHeader } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderHeader";
import { IWebsiteBuilderFooter } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderFooter";
import { IWebsiteBuilderSectionDataBase } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderSection";

export type TWebsiteBuilderSectionTraversalUpdate = <T extends IWebsiteBuilderSectionDataBase>(prev: T) => T;

export function sectionTraversal(
  header: IWebsiteBuilderHeader,
  root: IWebsiteBuilderRoot,
  footer: IWebsiteBuilderFooter,
  id: string,
  update: TWebsiteBuilderSectionTraversalUpdate,
): IWebsiteBuilderHistorySnapshot {
  let updatedHeader = header;
  let updatedFooter = footer;
  let updatedRoot = root;

  if (updatedHeader.id === id) {
    updatedHeader = {
      ...updatedHeader,
      section: update(updatedHeader.section),
    };
  } else if (updatedFooter.id === id) {
    updatedFooter = {
      ...updatedFooter,
      section: update(updatedFooter.section),
    };
  } else {
    updatedRoot = {
      ...updatedRoot,
      children: updatedRoot.children.map(child => {
        if (child.id === id) {
          return {
            ...child,
            section: update(child.section),
          };
        } else {
          return child;
        }
      }),
    };
  }

  return { header: updatedHeader, root: updatedRoot, footer: updatedFooter };
}